export const uk = {
    'day-budget': 'Средний дневной бюджет',
    'day-budget-custom': 'Бюджет на период',
    'day-budget-off': 'выключен',
    platform: 'Показывать',
    settings: 'Настройки',
    strategy: 'Стратегия'
};
